<p mat-dialog-title>{{title}}</p>
<mat-list style="width: 400px;" *ngFor="let company of companies; last as last">
    <mat-list-item style="padding-bottom: 25px; padding-top: 25px;"  *ngIf="company.hiringTypeId === 1 || idBenefit > 2">
        <span style="grid-column: 1">{{company.name}}</span>
        <mat-form-field style="position: absolute; right: 0px; margin-top: 13px;" appearance="outline" [style.width.px]=90 [style.padding-left.px]=30 [style.padding-right.px]=30>
            <input onfocus="this.select()" style="text-align: center;" matInput type="number" class="example-right-align" [(ngModel)]="company.benefits[idBenefit.toString()]['value']" [min]="minValue" [max]="maxValue">
            <mat-hint>{{hintText}}</mat-hint>
          </mat-form-field>
    </mat-list-item>
    <mat-divider *ngIf="company.hiringTypeId === 1"></mat-divider>
</mat-list>
<button style="margin-top: 25px; display: block;
margin-left: auto;
margin-right: auto;" mat-raised-button color="primary" (click)="closeDialog()">
<mat-icon>check</mat-icon>
</button>